import { Node } from '@tiptap/core';
import { VueNodeViewRenderer } from '@tiptap/vue-3';
import BlankView from '../views/BlankView.vue';
export default Node.create({
  name: 'BlankView',
  group: 'inline',
  draggable: false,
  inline: true,
  atom: true,
  selectable: true,

  addOptions() {
    return {
      locale: 'he',
    };
  },

  addAttributes() {
    return {
      id: {
        default: '',
      },
      model: {
        default: [],
        parseHTML: element => {
          const model = element.getAttribute('model');
          try {
            return model ? JSON.parse(model) : [];
          } catch (error) {
            console.warn('Failed to parse model attribute:', model, error);
            return [];
          }
        },
        renderHTML: attributes => {
          return {
            model: JSON.stringify(attributes.model || []),
          };
        },
      },
      locale: {
        default: this.options.locale,
        parseHTML: element =>
          element.getAttribute('locale') ?? this.options.locale,
        renderHTML: attributes => {
          return {
            locale: attributes.locale,
          };
        },
      },
    };
  },
  parseHTML() {
    return [
      {
        tag: 'blank',
      },
    ];
  },
  renderHTML({ HTMLAttributes }) {
    return ['div', HTMLAttributes];
  },
  addNodeView() {
    return VueNodeViewRenderer(BlankView, {
      stopEvent() {
        return false;
      },
    });
  },
});
